import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
    {
      path: '/',
      name: 'login',
      components: require(`../pages/home/main`)
    },
    {
      path: '/home/login',
      name: 'login',
      components: require(`../pages/home/login`)
    },
    {
      path: '/',
      components: require(`../components/master.vue`),
      children: [
        {
          path: '/home/index',
          name: 'home',
          components: require(`../pages/home/index`)
        },
        {
          path: '/sales/order_manage',
          name: 'order_manage',
          components: require(`../pages/sales/order_manage`)
        },
        {
          path: '/sales/order_detail/:orderCode',
          name: 'order_detail',
          components: require(`../pages/sales/order_detail`)
        },
        {
          path: '/guest/guest',
          name: 'guest',
          components: require(`../pages/guest/guest`)
        },
        {
          path: '/goods/goods',
          name: 'goods_search',
          components: require(`../pages/goods/goods`)
        },
        {
          path: '/goods/goods_type',
          name: 'goods_type',
          components: require(`../pages/goods/goods_type`)
        },
        {
          path: '/goods/product',
          name: 'product',
          components: require(`../pages/goods/product`)
        },
        {
          path: '/system/setting',
          name: 'sys_setting',
          components: require(`../pages/system/setting`)
        },
        {
          path: '/system/guestnogoods',
          name: 'guest_nogoods',
          components: require(`../pages/system/guest_nogoods`)
        },
        {
          path: '/system/config_sql',
          name: 'sys_config_sql',
          components: require(`../pages/system/config_sql`)
        },
        {
          path: '/system/db_tools',
          name: 'sys_db_tools',
          components: require(`../pages/system/db_tools`)
        }
      ]
    }
  ]

const router = new VueRouter({
  routes
})

export default router
